import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDataCommon } from "../../api/common";
import DetailSection from "../../components/DetailSection";

const NcsaBoard = ({ id = "ncsc" }) => {
  const [pageData, setPageData] = useState(null);
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      let type = "";
      if (id === "ncsc") {
        type = "aboutNCSC";
      } else if (id === "crc") {
        type = "aboutCRC";
      } else if (id === "cmo") {
        type = "aboutCMO";
      } else {
        navigate("/404");
      }

      const response = await getDataCommon(`${type}.json`);

      setPageData(response);
    } catch (error) {
      console.warn(error);
    }
  }, [setPageData, id]);

  useEffect(() => {
    getData();

    return () => {
      setPageData(null);
    };
  }, [getData]);

  return (
    <>
      <DetailSection
        pageTitle="เกี่ยวกับสำนักงาน"
        headerTitle={pageData?.title ?? ""}
        image={pageData?.topimage?.path}
        alt={pageData?.topimage?.altText}
        title={pageData?.headdetail ?? ""}
        content={pageData?.content ?? ""}
      />
    </>
  );
};

export default NcsaBoard;
